<form [formGroup]="form" class="flex flex-col gap-2">
    <div class="flex items-center justify-start gap-2">
        <mat-checkbox formControlName="privacyPolicy"></mat-checkbox>
        <p>
            <a [href]="privacyPolicyLink" target="_blank">
                {{ 'forms.accept-privacy-policy' | transloco }}*
            </a>
        </p>
    </div>
    <div
        *ngIf="form.controls['privacyPolicy'].touched && form.controls['privacyPolicy'].invalid"
        class="-mb-1 ml-2 text-xs text-error"
    >
        {{ 'messages.authentication.thisInputIsRequired' | transloco }}
    </div>

    <div class="flex items-center justify-start gap-2">
        <mat-checkbox formControlName="generalTerms"></mat-checkbox>
        <p>
            <a [href]="termsOfServiceLink" target="_blank">
                {{ 'forms.accept-general-terms' | transloco }}*
            </a>
        </p>
    </div>
    <div
        *ngIf="form.controls['generalTerms'].touched && form.controls['generalTerms'].invalid"
        class="-mb-1 ml-2 text-xs text-error"
    >
        {{ 'messages.authentication.thisInputIsRequired' | transloco }}
    </div>

    <div class="flex items-center justify-start gap-2">
        <mat-checkbox formControlName="newsLetter"></mat-checkbox>
        <p>
            {{ 'forms.accept-subscription-to-newsletter' | transloco }}
        </p>
    </div>
</form>
